import * as Animate from "react-reveal";

const rows = [
  { label: "Operations", before: "3–7 disconnected tools", after: "1 OS" },
  { label: "Speed", before: "42 days to hire", after: "1 week to hire" },
  { label: "Efficiency", before: "$8K per hire", after: "$3K per hire" },
  {
    label: "Payroll",
    before: "5 days to process payroll",
    after: "3-minute payroll",
  },
];

const HireCaseStudySection = () => {
  return (
    <section className="bg-[#0c0f49] py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-hire-proof gap-10 lg:gap-16">
        <Animate.Fade bottom>
          <div>
            <p className="text-secondary font-poppins text-sm font-extrabold tracking-widest uppercase mb-6">
              Global operations, compressed
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight text-white font-bold tracking-[-0.03em]">
              From disconnected tools to{" "}
              <span className="text-secondary">one operating system.</span>
            </h2>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="grid gap-2">
            <div className="hidden sm:grid grid-cols-2 gap-10 text-indigo-200 font-poppins text-sm font-extrabold tracking-widest uppercase pb-2 pl-[110px] pr-5">
              <span>Before Utiva</span>
              <span>With Utiva</span>
            </div>

            {rows.map((row) => (
              <article
                key={row.label}
                className="bg-white/[0.06] border border-white/20 rounded-2xl grid grid-cols-hire-proof-row items-center gap-4 md:gap-5 px-4 md:px-5 py-4 min-h-[92px]"
              >
                <small className="text-secondary font-poppins text-xs md:text-sm font-extrabold">
                  {row.label}
                </small>
                <p className="text-indigo-100 font-poppins m-0 text-sm md:text-base">
                  {row.before}
                </p>
                <b
                  aria-hidden="true"
                  className="text-secondary text-lg md:text-2xl not-italic font-normal"
                >
                  →
                </b>
                <strong className="text-white font-poppins text-base md:text-xl">
                  {row.after}
                </strong>
              </article>
            ))}
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default HireCaseStudySection;
